import { render, staticRenderFns } from "./product_hair.vue?vue&type=template&id=1f680796&scoped=true&"
import script from "./product_hair.vue?vue&type=script&lang=js&"
export * from "./product_hair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f680796",
  null
  
)

export default component.exports